import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_PROJECT_LAND_USE_AND_AREA',
  name: 'Workspace Project Land Use and Area',
  type: 'PROJECT',
  description: '',
  modules: [],
  fields: [
    { key: 'currentLandUsePlan', title: 'Current land use plan' },
    { key: 'description', title: 'Description' },
    { key: 'historicalDescription', title: 'Historical Description' },
    { key: 'createdAt', title: 'Date Created' },
    { key: 'updatedAt', title: 'Date Updated' },
  ],
  actions: ['READ', 'CREATE', 'UPLOAD', 'DESTROY'],
}

export default scope
